module.exports = __webpack_public_path__ + "img/norwegian_flag_colored.e07cbd53.png";